import { ValidationProps } from 'ui';
import { ComplexValue } from 'app/types-shared';

export enum FilterState {
  NoDefaultValue,
  DefaultValue,
  Range,
  FixedPeriod
}

export interface DefaultFilter {
  domain: ComplexValue<number>;
  required: boolean;
  sequence: number;
  myValue: boolean;
  defaultValue: ComplexValue<number>;
  defaultValue2: ComplexValue<number>;
  periodPredef: ComplexValue<number>;
  state: FilterState;
}

export type DefaultFilterValidation = {
  readonly [T in keyof DefaultFilter]?: ValidationProps;
};

export interface DefaultFilterMetadata {
  domain: ComplexValue<number>;
  advancedSearchType: number;
  codetable: number;
  categoryCodetable: number;
  searchRequired: boolean;
}

export interface DefaultFiltersCommonState {
  filters: DefaultFilter[];
  originalFilters: DefaultFilter[];
  filterMetadata: { [domain: number]: DefaultFilterMetadata };
  fetchingFilterMetadata: number[];
  filterValidation: { [domain: number]: DefaultFilterValidation };
}
